<p>operator-license works!</p>
